// extracted by mini-css-extract-plugin
module.exports = {"cta":"_2Sn5EfcE","disabled":"_1SqCHPNV","primary":"_13tHoREb","transparent":"_25wpaM4m","secondary":"_7RxF9OS5","fullWidth":"l7LJ6Dr-","small":"_1fW-CZGA","spinner":"_2XM1Nsr-"};